import { render, staticRenderFns } from "./mortgage.vue?vue&type=template&id=5f739627"
import script from "./mortgage.vue?vue&type=script&lang=js"
export * from "./mortgage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports